import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { TextComponent } from './components/text/text.component';
import { FileComponent } from './components/file/file.component';
import { McRAIToasterModule } from '../toaster/toaster.module';
import { McRAIButtonModule } from '../button/button.module';
import { FileSizePipe } from './pipes/file-size.pipe';
import { McRAICheckbox, McRAICheckboxGroup } from './components/checkbox/checkbox.component';
import { McRAIRadioGroup, McRAIRadio } from './components/radio/radio.component';
// import { DateComponent } from './components/date/date.component';
import { McRAIIconModule } from '../icon/icon.module';
// import { MatDatepickerModule, MatInputModule, MatNativeDateModule } from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    McRAIToasterModule,
    McRAIButtonModule,
    McRAIIconModule,
    // MatInputModule,
    // MatDatepickerModule,
    // MatNativeDateModule
  ],
  declarations: [
    TextComponent,
    FileComponent,
    McRAICheckbox,
    FileSizePipe,
    McRAICheckboxGroup,
    McRAIRadioGroup,
    McRAIRadio,
    // DateComponent
  ],
  exports: [
    TextComponent,
    FileComponent,
    McRAICheckbox,
    McRAICheckboxGroup,
    McRAIRadioGroup,
    McRAIRadio,
    // DateComponent
  ]
})
export class McRAIInputModule { }
